import { i18n } from '../../i18n';

export enum OptionType {
  WAYPOINTS = 'WAYPOINTS',
  GO_TO_LOCATION = 'GO_TO_LOCATION',
  MEASUREMENT_TOOL = 'MEASUREMENT_TOOL',
  CREATE_PRINT_MAP = 'CREATE_PRINT_MAP'
}

export interface OptionItem {
  type: OptionType;
  name: string;
  icon: string;
  isPro: boolean;
  action: () => void;
}

export const optionConfig: Record<OptionType, Omit<OptionItem, 'action'>> = {
  [OptionType.WAYPOINTS]: {
    type: OptionType.WAYPOINTS,
    get name() { return i18n.global.t('utils.option_item.waypoints'); },
    icon: 'place',
    isPro: false
  },
  [OptionType.GO_TO_LOCATION]: {
    type: OptionType.GO_TO_LOCATION,
    get name() { return i18n.global.t('utils.option_item.go_to_location'); },
    icon: 'my_location',
    isPro: false
  },
  [OptionType.MEASUREMENT_TOOL]: {
    type: OptionType.MEASUREMENT_TOOL,
    get name() { return i18n.global.t('utils.option_item.measurement_tool'); },
    icon: 'straighten',
    isPro: true
  },
  [OptionType.CREATE_PRINT_MAP]: {
    type: OptionType.CREATE_PRINT_MAP,
    get name() { return i18n.global.t('utils.option_item.create_print_map'); },
    icon: 'print',
    isPro: true
  }
};